import { Link, useSearchParams } from "react-router-dom";
import style from "./TabsNavigate.module.scss";
import cn from "classnames";

export function TabsNavigate() {
    const [queryParams] = useSearchParams();

    return (
        <div className={style.container}>
            <p className={style.pageName}>Налаштування</p>
            <div className={style.tabsButtons}> 
                <Link
                    className={cn(style.button, queryParams.get("tab") === "promo_codes" && style.button_active)}
                    to={".?tab=promo_codes"}
                >
                    Промокоди
                </Link>
                <Link
                    className={cn(style.button, queryParams.get("tab") === "payment_systems" && style.button_active)}
                    to={".?tab=payment_systems"}
                >
                    Платіжні системи
                </Link>
                <Link
                    className={cn(style.button, queryParams.get("tab") === "proxy_prices" && style.button_active)}
                    to={".?tab=proxy_prices"}
                >
                    Ціни на проксі
                </Link>
            </div>
        </div>
    )
}